<script>

import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'
import { interactionMixin } from 'src/modules/interactions_module.js'
import { favouriteInteractionMixin} from 'src/modules/favourite_interaction_module.js';

export default {
  mixins: [fandomBasicMixin, interactionMixin, favouriteInteractionMixin],
  data() {
    return {
      favouriteContentsContent: null
    };
  },
  mounted() {
    this.getFavouriteContents(false);
  },
  methods: {
    getFavouriteContents() {
      this.getContentsFromFavouriteList(
        null,
        Object.values(globalState.pageModel.name_to_content).map(obj => obj.id),
        (data) => {
          data.contents = data;
          Fandom.getContentsCallback(data.contents.main_content_name, data.contents, () => {
            if (!!this.favouriteContentsContent) {
              this.favouriteContentsContent.children = this.favouriteContentsContent.children.concat(data.contents.name_to_content[data.contents.main_content_name].children);
              this.favouriteContentsContent.has_more_children = data.contents.name_to_content[data.contents.main_content_name].has_more_children
            } else {
              Vue.set(this, 'favouriteContentsContent', data.contents.name_to_content[data.contents.main_content_name]);
            }
          })
        },
        'tile-ultrawide'
      );
    }
  },
  computed: {
  },
};
</script>

<template>
  <div v-easyadmin="easyadminId" v-if="isContentVisibleToUser()" :class="contentType"  stripe-favourite-component >
    <div class="container" v-if="content.title">
      <h3 class="font-weight-light my-4 my-md-5">{{content.title}}</h3>
    </div>
    <grid-isotope
      :alternativeAppendContents="getFavouriteContents"
      v-if="favouriteContentsContent"
      :content="favouriteContentsContent"
      tileSize="ultrawidecontent"
      :favouriteInteractions="true"
    ></grid-isotope>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .tile-icon-container {
  color: $white !important;
  background-color: $primary !important;
}
</style>